import React from 'react'
import { Experiment, Variation } from '@deal/experiment-js'
import ReatMarkdown from 'react-markdown'
import YoutubeEmbed from 'react-youtube'
import SidebarAwareGrid from '#src/components/SidebarAwareGrid'
import { GridItem } from '@deal/components'
import { SellableDetailsFragment } from '#src/generated/graphql'
import classnames from 'classnames'
import styles from './styles.css'

interface DescriptionProps {
  sellable: SellableDetailsFragment
  className?: string
}

const Description: React.SFC<DescriptionProps> = ({ sellable, className }) => {
  const videoReview =
    sellable.featuredContent &&
    sellable.featuredContent.externalVideos &&
    sellable.featuredContent.externalVideos[0]

  const sellableDescription = sellable.descriptionMarkdown ? (
    <ReatMarkdown source={sellable.descriptionMarkdown} />
  ) : sellable.descriptionText ? (
    sellable.descriptionText
  ) : null

  return (
    <>
      {sellableDescription && (
        <Experiment id="hide-product-description" default="on">
          <Variation id="on" />
          <Variation id="off">
            <SidebarAwareGrid>
              <GridItem col={2} mdCol={7}>
                <div className={classnames(styles.description, className)}>
                  {sellableDescription}
                </div>
              </GridItem>
            </SidebarAwareGrid>
          </Variation>
        </Experiment>
      )}
      {videoReview && (
        <SidebarAwareGrid>
          <GridItem col={2}>
            <div className={styles.videoContainer}>
              <div className={styles.videoReview}>
                <YoutubeEmbed
                  videoId={videoReview.id}
                  opts={{
                    width: '100%'
                  }}
                />
              </div>
            </div>
          </GridItem>
        </SidebarAwareGrid>
      )}
    </>
  )
}

export default Description
